module.exports = __webpack_public_path__ + "static/media/logo-lwazi-login.6cb771c5.svg";